import { render, staticRenderFns } from "./updatestudent.vue?vue&type=template&id=b4c16e72&"
import script from "./updatestudent.vue?vue&type=script&lang=js&"
export * from "./updatestudent.vue?vue&type=script&lang=js&"
import style0 from "./updatestudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports